import moment from 'moment'
export const getNow = () => {
  return moment().utcOffset(8 * 60)
}
export const dealerStartAt = data => {
  const startAt = data.start_at.split(':')
  // 由于我们规定的预约时间的格式必须在整点或者半点的情况
  // 所以这里需要对经销商的开业时间进行调整，以供全局使用
  // 默认是推迟经销商的营业时间 9：25 -> 9：30， 9：55 -> 10：00
  let startHour = parseInt(startAt[0])
  let startMins = parseInt(startAt[1])
  if (startMins > 0 && startMins <= 30) {
    startMins = 30
  } else if (startMins > 30 && startMins < 60) {
    startMins = 0
    startHour += 1
  }
  return [startHour, startMins]
}
export const dealerEndAt = data => {
  const endAt = data.end_at.split(':')
  return [parseInt(endAt[0]), parseInt(endAt[1])]
}
export const nextDayEndAt = data => {
  const endAt = data.next_day_end_time.split(':')
  return [parseInt(endAt[0]), parseInt(endAt[1])]
}
export const getEarliest = data => {
  let now = getNow()
  //最晚可预约时间
  // const nextDayEnd = now.clone().hour(nextDayEndAt(data)[0]).minute(nextDayEndAt(data)[1])
  const nextDayEnd = now
    .clone()
    .hour(16)
    .minute(55)
  let nextDayEndTime = null
  //如果当前时间小于16:55，则最早可预约时间为第二天的最晚可预约时间，否则是后天的最晚可预约时间
  if (now.isBefore(nextDayEnd)) {
    nextDayEndTime = nextDayEnd
      .clone()
      .add(1, 'day')
      .hour(nextDayEndAt(data)[0])
      .minute(nextDayEndAt(data)[1])
  } else {
    nextDayEndTime = nextDayEnd
      .clone()
      .add(2, 'day')
      .hour(nextDayEndAt(data)[0])
      .minute(nextDayEndAt(data)[1])
  }
  console.log('nextDayEndTime', moment(nextDayEndTime).format('YYYY-MM-DD HH:mm'))

  //经销商结束时间
  let earliestDealerEnd = nextDayEndTime
    .clone()
    .hour(dealerEndAt(data)[0])
    .minute(dealerEndAt(data)[1])
  if (nextDayEndTime.isSameOrBefore(earliestDealerEnd)) {
    // 在普通订单的情况下，如果最早可以预约的时间小于经销商的营业结束时间，最早可在极速订单结束时预约
    return nextDayEndTime
  } else {
    // 否则这一天是不可以预约的，最早时间是第二天一大早（经销商的开门时间）
    let date = nextDayEndTime
      .clone()
      .add(1, 'day')
      .hour(dealerStartAt(data)[0])
      .minute(dealerStartAt(data)[1])
    return date
  }
}
export const defaultTime = time => {
  const m = time.clone()
  return moment(time).format(`YYYY-MM-DD 星期${'一二三四五六日'[m.isoWeekday() - 1]} HH:mm`)
}
export const getDateArr = date => {
  let earliestYear = Number(moment(date).format('YYYY'))
  let earliestMonth = Number(moment(date).format('MM')) - 1
  let earliestDate = Number(moment(date).format('DD'))
  let earliestHour = Number(moment(date).format('HH'))
  let earliestMinute = Number(moment(date).format('mm'))
  return [earliestYear, earliestMonth, earliestDate, earliestHour, earliestMinute] //,earliestHour,earliestMinute
}
export const cutTime = (time, string) => {
  return time.split(string)
}
export const delWeek = time => {
  const reg = /\s[\u4e00-\u9fa5]*\s/g
  return time.replace(reg, ' ')
}
